// External JS
import {MzcOAuthPortal} from '@zyxel-nebula/mzc-oauth';

console.info('welcome to', process.env.SERVICE_GROUP, process.env.NEBULA_HOST_DOMAIN);

const TERMS_OF_USE_URL = 'https://bulletin.nebula.zyxel.com/data-policies/NCC_TermsOfUse_20180731.en-us.html';

// get MZC session
const appKey = process.env.MZC_OAUTH.app_key;
const mzcHost = process.env.MZC_OAUTH.desktop;
const LoginRedirect = `${location.protocol}//${location.host}/cc/index.html`;
const LogoutRedirect = `${location.protocol}//${location.host}/`;
const mzc = new MzcOAuthPortal(appKey, LoginRedirect, LogoutRedirect, mzcHost);

const Login = () => {
    console.info('login button pressed or CD/SSO triggered');
    mzc.login();
};

const ACCESS_DENIED_PATH = process.env.CUSTOM_DOMAIN?.INVALID_DOMAIN || '/access-denied.html';
const REQUEST_TIMEOUT_MS = 5000;
const HTTP_STATUS_OK = 200;
const HTTP_STATUS_FORBIDDEN = 403;

const GATEWAY_API = process.env.CUSTOM_DOMAIN?.GATEWAY_API;

const checkCustomDomain = async () => {
    const controller = typeof window.AbortController !== 'undefined' ? new window.AbortController() : null;
    const timeoutId = controller ? window.setTimeout(() => controller.abort(), REQUEST_TIMEOUT_MS) : null;

    try {
        const response = await window.fetch(GATEWAY_API, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
            },
            signal: controller?.signal,
        });
        if (timeoutId) {
            window.clearTimeout(timeoutId);
        }

        return response.status;
    } catch (error) {
        if (timeoutId) {
            window.clearTimeout(timeoutId);
        }
        console.error('[checkCustomDomain] error:', error);
        return null;
    }
};

const revealWelcomePage = () => {
    document.body.classList.remove('pending');
    document.querySelector('.main')?.classList.remove('oauth');
};

const runSSOFlow = () => {
    console.info('sso status check');
    const ssoImg = new Image();
    ssoImg.onload = function () {
        Login();
    };
    ssoImg.onerror = function () {
        revealWelcomePage();
    };
    ssoImg.src = process.env.MZC_OAUTH.session_oauth;
};

const isCustomDomainCandidate = (hostname = location.hostname) => {
    const pattern = (process.env.CUSTOM_DOMAIN?.DOMAIN_PATTERN || '').trim().toLowerCase();
    if (!pattern) {
        return false;
    }

    return hostname.toLowerCase().endsWith(`.${pattern}`);
};

const init = async () => {
    const sessionData = window.sessionStorage.getItem('nebula://session/continuity');
    if (sessionData && sessionData.includes('/wizard')) {
        Login();
        return;
    }

    if (!isCustomDomainCandidate()) {
        runSSOFlow();
        return;
    }

    const status = await checkCustomDomain();
    if (status === HTTP_STATUS_OK) {
        console.info('[CustomDomain] Valid custom domain detected, triggering login directly.');
        Login();
        return;
    }

    if (status === HTTP_STATUS_FORBIDDEN) {
        console.warn('[CustomDomain] Unauthorized custom domain, redirecting to access-denied.');
        location.replace(ACCESS_DENIED_PATH);
        return;
    }

    runSSOFlow();
};

init();

document.querySelector('#btn-login')?.addEventListener('click', Login);

const termsOfUserLink = document.querySelector('#termsOfUserLink');
const termsOfUserDialog = document.querySelector('#termsOfUserDialog');
const termsOfUseIframe = document.querySelector('#termsOfUseIframe');
const isTermsDialogSupported =
    typeof window.HTMLDialogElement !== 'undefined' &&
    typeof window.HTMLIFrameElement !== 'undefined' &&
    termsOfUserDialog instanceof window.HTMLDialogElement &&
    termsOfUseIframe instanceof window.HTMLIFrameElement;

if (isTermsDialogSupported) {
    termsOfUserLink?.addEventListener('click', () => {
        if (!termsOfUseIframe.src) {
            termsOfUseIframe.src = TERMS_OF_USE_URL;
        }
        if (!termsOfUserDialog.open) {
            termsOfUserDialog.showModal();
        }
    });

    termsOfUserDialog.querySelectorAll('[data-dialog-close]').forEach((closeButton) => {
        closeButton.addEventListener('click', () => {
            termsOfUserDialog.close();
        });
    });

    termsOfUserDialog.addEventListener('click', (event) => {
        if (event.target === termsOfUserDialog) {
            termsOfUserDialog.close();
        }
    });
}
